import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useRef } from 'react';
import { connect, Provider, createStoreHook, createDispatchHook, createSelectorHook } from 'react-redux';
import { createStore, applyMiddleware, combineReducers, bindActionCreators } from 'redux';
import { fork, all } from 'redux-saga/effects';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { reducers as streamReducers, sagas as streamSagas } from '../../Stream';
import { entitiesReducers } from '../../redux/entities';
import sharedConfigReducers from '@wix/da-redux-config/pkg/reducers';
import publicSessionReducers from '../../publicSession/reducers';
import modalsReducers from '../../Modals/redux/reducer';
import modalsSaga from '../../Modals/redux/saga';
import uploadsReducers from '../../redux/uploads/reducers';
import uploadsSaga from '../../redux/uploads/saga';
import deviationsSaga from '../../redux/deviations/saga';
import { initialize as initConfig } from '@wix/da-redux-config/pkg/actions';
import { getConfig } from '@wix/da-redux-config/pkg/selectors';
import { getPublicSession } from '../../publicSession/selectors';
import { initialize as initPublicSession } from '../../publicSession/actions';
import { getFlags } from '@wix/da-react-context/pkg/flags/redux/selectors';
import flagsReducers from '@wix/da-react-context/pkg/flags/redux/reducer';
import { setFlags } from '@wix/da-react-context/pkg/flags/redux/actions';
import mediaPopupReducers from '../reducers';
import mediaPopupSaga from '../saga';
const MediaContext = /*#__PURE__*/ React.createContext(null);
MediaContext.displayName = 'MediaContext';
export const useMMStore = createStoreHook(MediaContext);
export const useMMSelector = createSelectorHook(MediaContext);
export const useMMDispatch = createDispatchHook(MediaContext);
export function useMMDispatchActions(actions) {
    const MMDispatch = useMMDispatch();
    const boundActionsRef = useRef(bindActionCreators(actions, MMDispatch));
    return boundActionsRef.current;
}
export const connectMediaStore = (mapStateToProps = null, mapDispatchToProps = null, mergeProps = null, options = {})=>{
    options.context = MediaContext;
    return connect(mapStateToProps, mapDispatchToProps, mergeProps, options);
};
export const reducers = _object_spread({}, sharedConfigReducers, entitiesReducers, streamReducers, publicSessionReducers, mediaPopupReducers, flagsReducers, modalsReducers, uploadsReducers);
export const sagas = [
    mediaPopupSaga,
    ...streamSagas,
    modalsSaga,
    uploadsSaga,
    deviationsSaga
];
export function* rootSaga() {
    yield all(sagas.map(fork));
}
const withOwnReduxStore = (Component)=>{
    const enhance = connect((state)=>({
            config: getConfig(state),
            publicSession: getPublicSession(state),
            flags: getFlags(state)
        }));
    class ComponentWithOwnReduxStore extends React.Component {
        render() {
            return /*#__PURE__*/ React.createElement(Provider, {
                context: MediaContext,
                store: this.store
            }, /*#__PURE__*/ React.createElement(Component, this.props));
        }
        constructor(props){
            super(props);
            _define_property(this, "store", void 0);
            const { config, flags, publicSession } = props;
            const sagaMiddleware = createSagaMiddleware();
            const composeEnhancers = composeWithDevTools({
                name: 'MediaPopup'
            });
            this.store = createStore(combineReducers(reducers), composeEnhancers(applyMiddleware(sagaMiddleware)));
            this.store.dispatch(initConfig(config));
            this.store.dispatch(initPublicSession({
                sessionData: publicSession
            }));
            this.store.dispatch(setFlags(flags));
            sagaMiddleware.run(rootSaga);
        }
    }
    return enhance(ComponentWithOwnReduxStore);
};
export default withOwnReduxStore;
